import * as _ from 'underscore';
import * as ng from 'angular';

import { Experience, ExperienceTypeDef } from '../../';
import { EditorModel } from '../../editor/editor.model';
import { EditorPageModel } from '../../editor/editor-page.model';

const settingsViewUrl = require('./media-settings.html');

ng.module('e360')
   .factory('mediaEditorModelFactory', mediaEditorModelFactory);

mediaEditorModelFactory.$inject = ['instanceServiceFactory'];
function mediaEditorModelFactory(instanceServiceFactory) {
   return instanceServiceFactory(MediaEditorModel);
}

// ExperienceTypeDef' is an unused renaming of 'typeDef'. Did you intend to use it as a type annotation?
export interface MediaEditorModelFactory {
   ({campaign, typeDef:ExperienceTypeDef, experience:Experience}):MediaEditorModel
}

export class MediaEditorModel extends EditorModel {
   readonly workspaceClass: string;
   readonly pages: MediaPageModel[];
   readonly settingsView: string = settingsViewUrl;
   readonly mediaUrl:string;
   templateId:string;

   static $inject = [
      '$http',
      '$templateCache',
      'session',
      'l10n',
      'gettextCatalog',
      'editorCodeParser'
   ].concat(['campaign', 'typeDef', 'experience']);

   constructor(
      private $http,
      private $templateCache:ng.ITemplateCacheService,
      private session,
      private l10n,
      private gettextCatalog,
      private editorCodeParser,
      campaign, typeDef: ExperienceTypeDef, experience: Experience
   ) {
      super(campaign, typeDef, experience);

      gettextCatalog.getString("I'm having a great time.");
      gettextCatalog.getString('Media Page');
      gettextCatalog.getString('Your Photo');
      gettextCatalog.getString('<p>Thanks for attending!</p>');

      this.mediaUrl = `//${this.session.defaultMediaDomain()}`;
      this.hasSettings = true;
      this.hasPreview = true;
      this.workspaceClass = 'media';
      this.previewUrl = `${this.mediaUrl}/preview/${this.session.getCampaign().slug}`;

      let brandSettings = this.session.getBrand().settings.experience;
      let defaults:any = {
         backgroundColor: brandSettings.backgroundColor,
         font: brandSettings.mediaFont,
         fontSize: brandSettings.fontSize,
         fontColor: brandSettings.fontColor,
         footerBackgroundColor: brandSettings.footerBackgroundColor,
         footerFontSize: brandSettings.footerFontSize,
         footerFontColor: brandSettings.footerFontColor,
         footerLinkColor: brandSettings.footerLinkColor,
         footerText: {},
         headerFontSize: brandSettings.headerFontSize,
         socialLinkColor: brandSettings.socialLinkColor,
         socialLinkHoverColor: brandSettings.socialLinkHoverColor,
         linkColor: brandSettings.linkColor,
         mirrorCampaignFooter: true,
         uploads: {
            headerImage: brandSettings.uploads.genericHeader
         },
      };

      if (this.isNew) {
         this.experience = {
            campaignId: campaign.id,
            type: typeDef.id,
            settings: ng.copy(defaults)
         };
      }

      this.l10n.translateObject(
         this.experience.settings,
         'pageTitle',
         'Media Page',
         this.languages
      );

      this.l10n.translateObject(
         this.experience.settings,
         'headerText',
         "Your Photo",
         this.languages
      );

      this.l10n.translateObject(
         this.experience.settings,
         'bodyText',
         "<p>Thanks for attending!</p>",
         this.languages
      );

      this.pages = [new MediaPageModel(this)];
   }

   init() {
      let url = `${this.mediaUrl}/app/media.html`;

      return this.$http.get(url).then(result => {
         let html = [
            '<html>',
            '<head><link rel="stylesheet" href="' + this.mediaUrl + '/app.css"></head>',
            '<body>' + result.data + '</body>',
            '</html>'
         ].join('\n');

         return this.editorCodeParser(html, false, this.mediaUrl).then(doc => {
            this.templateId = 'media-editor-view';
            this.$templateCache.put(this.templateId, doc.html);
         });
      })
   }
}

class MediaPageModel extends EditorPageModel {
   constructor(editor: MediaEditorModel) {
      super(editor);
   }

   get view() {
      return (this.editor as MediaEditorModel).templateId;
   }

   get settings() {
      return this.editor.settings;
   }
}
